import { formatCpDate } from '@cp-shared-19/common-utilities';
import { DATE_FORMAT } from 'cpes-common';

export type FormValues = {
    settlementDate: string;
};

export const getInitialValues = (): FormValues => ({
    settlementDate: formatCpDate().format(DATE_FORMAT),
});
